import React, { useState, useEffect } from "react";
import axios from '../helper/axios';
import Autocomplete from "@mui/material/Autocomplete";
import { TextField, InputAdornment, IconButton } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useUser } from "../Provider";
const SearchBedType = ({ onBedTypeChange, hospitalvalue }) => {
    const { userrole1, token } = useUser();
    const [data,setBedTypes] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState('');
    const [openAutocomplete, setOpenAutocomplete] = useState(false);

    useEffect(() => {
        fetchBedTypes();
        setSelectedCategory("");
    }, [hospitalvalue, userrole1]);

    const fetchBedTypes = async () => {
        try {
          const response = await axios.get("/getbedtype", {
            headers: {
              Authorization: `Bearer ${token}`,
            },
            params: {
              hospitalcode: hospitalvalue,
            },
          });
    
          if (response.status === 200) {
            setBedTypes(response.data);
          } else {
            console.error(`Failed to fetch available bed types with status: ${response.status}`);
          }
        } catch (error) {
          console.error('Error fetching available bed types:', error.message);
        }
      };
      const handleExpandClick = () => {
        setOpenAutocomplete(!openAutocomplete);
    };

    const handleCategoryChange = (event, value) => {
      if (value) {
        setSelectedCategory(value);
        onBedTypeChange(value);
    } else {
        // Handle the case when no value is selected
        setSelectedCategory('');
    }
    };
    const getOptionLabel = (option) => {
      // Handle the case when option is null or undefined
      return option?.bedtype || '';
  };
    return (
        <div className="searchbar">
            <Autocomplete
                freeSolo
                id="free-solo"
                options={data}
                getOptionLabel={getOptionLabel}
                open={openAutocomplete}
                onOpen={() => setOpenAutocomplete(true)}
                onClose={() => setOpenAutocomplete(false)}
                value={selectedCategory}
                onChange={handleCategoryChange}
                renderInput={(params) =>
                    <TextField
                        {...params}
                        placeholder="Select Bed Type"
                        InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton onClick={handleExpandClick}>
                                        <ExpandMoreIcon />
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                    />
                }
            />
        </div>
    );
};

export default SearchBedType;